/**
 * Selection cycling popup state (Faz 4.4 — OCS selection cycling parity).
 *
 * When the SELECTIONCYCLING display mode is on and a click's ray pierces
 * two or more stacked entities, the selection router opens this popup
 * instead of silently advancing: the candidate rows (type / layer / color)
 * are the one-click pick list AutoCAD shows for overlapping objects.
 * Pure transient UI state — nothing here persists.
 */

import { create } from 'zustand';

export interface SelCycleCandidate {
    id: string;
    type: string;
    layerName: string;
    /** Entity color as written in the data bag (undefined = BYLAYER ink). */
    color?: string;
}

interface SelCycleState {
    visible: boolean;
    /** Screen position of the pick (client coordinates). */
    position: { x: number; y: number };
    candidates: SelCycleCandidate[];

    open: (x: number, y: number, candidates: SelCycleCandidate[]) => void;
    close: () => void;
}

export const useSelCycleStore = create<SelCycleState>((set) => ({
    visible: false,
    position: { x: 0, y: 0 },
    candidates: [],

    open: (x, y, candidates) => set({ visible: true, position: { x, y }, candidates }),
    close: () => set({ visible: false, candidates: [] }),
}));
